<template>
  <div>
    <div style = "float: left; max-width: 0px">
      <input type="text" class="schinput" v-model="val" :readonly="readonly" @keypress.enter="searchVal" @keydown="keyDown"/>
    </div>
    <div v-if="!readonly">
      <button style = "float: right;margin-top: 10px;" type="button" class="icon" @click="openPopup"><i class="fas fa-search"></i></button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      val: '',
      readonly: false
    }
  },
  created() {
    /** 출고일자, 출고수량 체크  **/

    /** 업무관리 > 요청자재출고 메뉴에서 해당 팝업창 여는 조건이 다르다. **/
    if (this.$route.fullPath === '/ReqMateEnter') {
      if(this.params.data.outDt == null){
        this.readonly = false
      }else{
        this.readonly = true
      }
    }
    else {
      if(this.params.data.invtGoodQty <= 0){
        this.readonly = true
      }else{
        this.readonly = false
      }
    }
  },
  methods: {
    openPopup(){
      if(this.params.onModal == 'Y'){
        console.log('this.params',this.params.val);
        this.$parent.$parent.$parent.mainRowIndex = this.params.val;
        const funcNm = this.params.funcNm;
        this.$parent.rowIdx = this.params.node.rowIndex;
        this.$parent.rowId = this.params.node.id;
        this.$parent.$parent.$parent[funcNm]();
      } else
      if(this.params.funcNm){
        const funcNm = this.params.funcNm;
        this.$parent.$parent.rowIdx = this.params.node.rowIndex;
        this.$parent.$parent.rowId = this.params.node.id;
        this.$parent.$parent[funcNm]();
      }
    },
    searchVal(){

      if(this.params.valFuncNm){
        var funcNm = this.params.valFuncNm;
        this.$parent.$parent.rowIdx = this.params.node.rowIndex;
        this.$parent.$parent.rowId = this.params.node.id;
        this.$parent.$parent[funcNm](this.val);
      }
    },
    keyDown(e) {
      //좌우측 방향키 눌림시 다음 컬럼 넘어감 방지
      if(e.code === "F2" || e.code === "End" || e.code === "Home" || e.code === "ArrowLeft" || e.code === "ArrowRight"){
        e.stopPropagation()
      }
    }
  },
  watch: {
    'value': {
      immediate: true,
      deep: true,
      handler() {
        this.val = this.params.value;
      }
    }
  }
});
</script>
<style>
.schinput {
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
  color: inherit;
  border-width: 0px;
  border-style: none;
  min-height: 40px;
  height: 100%;
  min-width: 300px;
  background-color: rgba(255,255,255,0.0);
}

.schinput:read-only{
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
  color: inherit;
  border-width: 0px;
  border-style: none;
  min-height: 40px;
  height: 100%;
  background-color: rgba(255,255,255,0.0);
}

.schinput:focus{
  outline: none;
}

</style>

